import { IGenericAction, IGenericStoreAction } from '../../services/app-action';

export const GENERIC_STORE_ACTION = 'GENERIC_STORE:';
export const GENERIC_DISPATCHER_ACTION = 'GENERIC_ACTION:';

export interface IGenericStoresState<T extends object = {}> {
    [storeId: string]: T;
}

export function genericStoreAction<S>(storeId: string, state: S): IGenericStoreAction<S> {
    return {
        storeId,
        state,
        type: GENERIC_STORE_ACTION
    };
}

export function genericDispatcherAction<S>(eventName: string, data: S): IGenericAction<S> {
    return {
        eventName,
        data,
        type: GENERIC_DISPATCHER_ACTION
    };
}

export function generic<T extends object = {}>(
    state: IGenericStoresState<T> = {},
    action: IGenericStoreAction<T>
): IGenericStoresState {
    if (action.type === GENERIC_STORE_ACTION) {
        const result = { ...state };
        const current = result[action.storeId] || {};
        result[action.storeId] = { ...current, ...action.state };
        return result;
    }
    return state;
}
